define((require) => {
    "use strict";

    const _             = require("underscore");
    const $             = require("jquery");
    const Configuration = require("shared/services/Configuration");
    const Preconditions = require("shared/util/Preconditions");

    // Regex to search for a server 4xx/5xx status/error code in the document title as websites tend to
    // return a valid html document alongside 404's, for example. We have no way of accessing load failures
    // like this via iframe elements, so this is an attempt to detect this (on same domains). On success,
    // that is on for example a detected 404, we simply report this via the frontend error logger so we
    // can track such issues and help our clients...
    const ERROR_CODE = /(?:^|\D)(4\d\d|5\d\d)(?:\D|$)/;

    /**
     * A mixin defining functionality to create iframes related to embedding urls, e.g. in a Lightbox or via
     * an EmbedWidget.
     */
    return {
        __typeName: "EmbedMixin",

        /**
         * @private
         * Creates a new iframe for embedding, optionally with the specified attributes. The url to be embedded
         * may represent an embedded Viewer (Group or Experience), or just some random (cross domain) url. <p>
         *
         * The iframe is not inserted into any document when returned. The "src" property will not be set to
         * <tt>descriptor.url</tt>; it must explicitly be set via <tt>attrs</tt> if required here.
         *
         * @param  {*} descriptor The url descriptor; cannot be falsey.
         * @param  {*} [attrs]    Optional iframe attributes; can be falsey/empty.
         *
         * @return {jQuery} A jQuery element wrapping the created iframe; never falsey.
         */
        _createIframe(descriptor, attrs) {
            attrs = _.extend({allowFullscreen: true}, attrs);

            // Embedded Viewer? If so, we must tag the iframe as such as this is used by ViewerProxy...
            if (descriptor.type !== "url") {
                attrs["data-zmags-viewer"] = Configuration.version;
            }

            return $("<iframe />", attrs);
        },

        /**
         * @private
         * Attempts to find a http 4xx/5xx status/error code for the specified iframe window. <p>
         *
         * If such a code is returned, a prudent message will have been logged via the frontend error logger,
         * if enabled.
         *
         * @param  {Window} iframeWin The iframe window; cannot be falsey, and should be accessible.
         * @return {String} The http 4xx/5xx status/error code if so deduced, otherwise falsey.
         */
        _statusCode(iframeWin) {
            try {
                let code = ERROR_CODE.exec(iframeWin.document.title);
                if (code) {
                    code = code[1]; // [1] stores the actual code.
                    Preconditions.warn(`Potential '${code}' status code for ${this.__typeName}: '${iframeWin.location}'`); // warn so we can track it
                }
                return code;
            } catch (e) { // e.g. SecurityError on cross domain
                // Fall-through
            }
        }

    };
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/embedWidget/EmbedMixin.js